import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/app/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { useState } from 'react';
import { Playground, Props } from 'docz';
import ThemeProvider from '../Theme/ThemeProvider';
import Checkbox from './Checkbox';
import { WithState } from '../DataGridv2/utils';
import Flex from '../Layout/Flex';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <h2 {...{
      "id": "basic-usage"
    }}>{`Basic usage`}</h2>
    <Playground __position={0} __code={'<ThemeProvider>\n  <Checkbox\n    onChange={(evt, checked) => {\n      console.log(\'checked\', checked)\n    }}\n  />\n</ThemeProvider>'} __scope={{
      props,
      DefaultLayout,
      useState,
      Playground,
      Props,
      ThemeProvider,
      Checkbox,
      WithState,
      Flex,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  <ThemeProvider mdxType="ThemeProvider">
    <Checkbox onChange={(evt, checked) => {
          console.log('checked', checked);
        }} mdxType="Checkbox" />
  </ThemeProvider>
    </Playground>
    <h1 {...{
      "id": "props-api"
    }}>{`props API`}</h1>
    <Props of={Checkbox} mdxType="Props" />
    <h1 {...{
      "id": "defaultchecked"
    }}>{`defaultChecked`}</h1>
    <Playground __position={2} __code={'<ThemeProvider>\n  <Checkbox\n    defaultChecked={true}\n    onChange={(evt, checked) => {\n      console.log(\'checked\', checked)\n    }}\n  />\n</ThemeProvider>'} __scope={{
      props,
      DefaultLayout,
      useState,
      Playground,
      Props,
      ThemeProvider,
      Checkbox,
      WithState,
      Flex,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  <ThemeProvider mdxType="ThemeProvider">
    <Checkbox defaultChecked={true} onChange={(evt, checked) => {
          console.log('checked', checked);
        }} mdxType="Checkbox" />
  </ThemeProvider>
    </Playground>
    <h1 {...{
      "id": "controlled"
    }}>{`Controlled`}</h1>
    <Playground __position={3} __code={'<ThemeProvider>\n  <WithState defaultState={true}>\n    {(state, setState) => (\n      <Checkbox\n        checked={state}\n        onChange={(evt, checked, name) => setState(checked)}\n      />\n    )}\n  </WithState>\n</ThemeProvider>'} __scope={{
      props,
      DefaultLayout,
      useState,
      Playground,
      Props,
      ThemeProvider,
      Checkbox,
      WithState,
      Flex,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  <ThemeProvider mdxType="ThemeProvider">
    <WithState defaultState={true} mdxType="WithState">
      {(state, setState) => <Checkbox checked={state} onChange={(evt, checked, name) => setState(checked)} mdxType="Checkbox" />}
    </WithState>
  </ThemeProvider>
    </Playground>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      